import {
  CONTACT_MODAL_CLOSED,
  CONTACT_MODAL_OPENED,
  REBATE_TERMS_MODAL_CLOSED,
  REBATE_TERMS_MODAL_OPENED,
  WELCOME_MODAL_CLOSED,
  WELCOME_MODAL_OPENED,
  CONSULTATION_MODAL_CLOSED,
  CONSULTATION_MODAL_OPENED,
  TOUR_MODAL_CLOSED,
  TOUR_MODAL_OPENED
} from '../constants'

export const closeContactModal = () => ({ type: CONTACT_MODAL_CLOSED })
export const openContactModal = (options) => ({
  type: CONTACT_MODAL_OPENED,
  options
})

export const closeRebateTermsModal = () => ({ type: REBATE_TERMS_MODAL_CLOSED })
export const openRebateTermsModal = () => ({ type: REBATE_TERMS_MODAL_OPENED })

export const closeWelcomeModal = () => ({ type: WELCOME_MODAL_CLOSED })
export const openWelcomeModal = () => ({ type: WELCOME_MODAL_OPENED })

export const closeConsultationModal = () => ({
  type: CONSULTATION_MODAL_CLOSED
})
export const openConsultationModal = () => ({ type: CONSULTATION_MODAL_OPENED })

export const closeTourModal = () => ({ type: TOUR_MODAL_CLOSED })
export const openTourModal = (options) => ({ type: TOUR_MODAL_OPENED, options })



// WEBPACK FOOTER //
// ./src/actions/modals.js